import { Flex, Text } from "@mantine/core";

export default function StationNowPlaying({ info }) {
  if (!info || !info.is_song) return null;

  return (
    <Flex justify="center">
      <Text size="xs" c="dimmed" align="center">
        Now playing: {info.name} by {info.artist}
      </Text>
    </Flex>
  );
}
